Preloader2.inlineTrigger = function(onComplete, delay){
    var index = this.inlineTriggers.length
    if(!Igloo.defined(delay)) delay = 10;

    this.inlineTriggers[index] = {onComplete:onComplete,delay:delay};
    return " onload=\"console.log('here-----');Preloader2.rit("+index+")\" ";
}

function AnimationController({
    containerSelector,
    triggerStart = 'top bottom' ,
    triggerEnd = 'top top',
    items,
    showMarkers = false,
}) {

    this.log = false;

    // if (this.log) console.log(`%c[animationController]`, 'background:pink', `New instance`, containerSelector);

    this.containerSelector = containerSelector;
    this.triggerStart = triggerStart;
    this.triggerEnd = triggerEnd;
    this.items = items;
    this.showMarkers = showMarkers;
    
    this.container = document.querySelector(containerSelector);

    if (!this.items) {
        if (this.log) console.log(`%c[animationController]`, 'background:pink', `No items for ${containerSelector}`);
        return;  
    } 

    this.resizeDelegate = jstage.addListener("resize", Igloo.delegate(this, this.onResize));
    this.onResize();

    this.animationLabel = `animation${Date.now()}`;
    
    gsap.registerPlugin(ScrollTrigger);
    this.timeline = gsap.timeline();

    this.calculateContainerBaseDimensions();
    
    this.animateItemsTimeline();
    
    this.createAnimation();
    
}

AnimationController.prototype.calculateContainerBaseDimensions = function() {
    if (this.log) console.log('%c[animationController]', 'background: pink', 'calculateContainerBaseDimensions');
        
    if (this.container) {
        const newContainerBaseX = this.container.offsetWidth / 2 / 100;
        const newContainerBaseY = this.container.offsetHeight / 2 / 100;
        if (newContainerBaseX !== this.containerBaseX || newContainerBaseY != this.containerBaseY) {
            if (this.log) console.log(this.container.offsetWidth, this.container.offsetHeight)
            this.containerBaseX = newContainerBaseX;
            this.containerBaseY = newContainerBaseY;
            this.setItemsInitialPosition();
            ScrollTrigger.refresh();
        }
    }

}

AnimationController.prototype.setItemsInitialPosition = function() {
    // console.log('setItemsInitialPosition')
    this.items.forEach(({selector, start}) => {
        const item = document.querySelector(selector);
        item.style.transform = `translate(${this.containerBaseX * start.x}px, ${this.containerBaseY * start.y}px)`;
    })
}

AnimationController.prototype.createAnimation = function() {
    if (this.container) {
        this.animation = ScrollTrigger.create({
            trigger: this.containerSelector,
            animation: this.timeline,
            markers: this.showMarkers,
            start: this.triggerStart,
            end: this.triggerEnd,
            scrub: .5,
            invalidateOnRefresh: true
        });
    }
}

AnimationController.prototype.refresh = function() {
    this.calculateContainerBaseDimensions();
    ScrollTrigger.refresh();
}
AnimationController.prototype.onResize = function() {
    // if (this.log) console.log('%c[animationController]', 'background: pink', 'onResize');
    this.refresh();
}

AnimationController.prototype.animateItemsTimeline = function() {
    if (this.container) {
        this.items.forEach(item => {
            this.animateItemTimeline(item);
        })
    }
}

AnimationController.prototype.animateItemTimeline = function({
    selector,
    start,
    end,
    delay = 0,
    duration = 1,               // uses the largest number and makes others relative to it (if using ScrollTrigger)
    ease = "sine.inOut"
}) {

    // Eases: https://greensock.com/docs/v3/Eases

    const item = document.querySelector(selector);
    
    this.timeline.fromTo(
        selector, 
        {
            x: () => this.containerBaseX * start.x,
            y: () => this.containerBaseY * start.y
        },
        {
            x: () => this.containerBaseX * end.x,
            y: () => this.containerBaseY * end.y,
            duration,
            delay,
            ease
        },
        this.animationLabel
    );
}